import { apiService } from "../services/api";

export type ReportFooterModuleMeta = { key: string; label: string };

export type ReportFooterModuleContact = {
  email: string;
  website: string;
};

export type ReportFooterOverlay = {
  bottom_px: number;
  right_px: number;
  font_size_px: number;
  color: string;
};

export type ReportFooterSettingsPayload = {
  overlay?: ReportFooterOverlay;
  overlay_wide?: ReportFooterOverlay;
  modules?: Record<string, ReportFooterModuleContact>;
};

export type ReportFooterSettingsResponse = {
  success?: boolean;
  setting?: ReportFooterSettingsPayload;
  meta?: ReportFooterModuleMeta[];
  message?: string;
};

export async function getReportFooterSettings(): Promise<ReportFooterSettingsResponse> {
  return (await apiService.get(
    "/pabws/api/report_footer_settings"
  )) as ReportFooterSettingsResponse;
}

export async function saveReportFooterSettings(
  payload: ReportFooterSettingsPayload
): Promise<ReportFooterSettingsResponse> {
  return (await apiService.post(
    "/pabws/api/report_footer_settings",
    payload
  )) as ReportFooterSettingsResponse;
}
